import { CssUtil } from '@root/shared'

import type { Provider } from '../../model'

type ProviderColors = {
  text: string
  bg: string
}

const ORCA = { text: '#F2C45B', bg: CssUtil.addTransparency('#F2C45B', 0.95) }
const JUPITER = {
  text: '#C6F462',
  bg: CssUtil.addTransparency('#C6F462', 0.95),
}
const METEORA = {
  text: '#FF9E3E',
  bg: CssUtil.addTransparency('#FF7F00', 0.95),
}
const RAYDIUM = {
  text: '#565AFF',
  bg: CssUtil.addTransparency('#565AFF', 0.95),
}
const BONK_FUN = {
  text: '#FFDD02',
  bg: CssUtil.addTransparency('#FFDD02', 0.95),
}
const UNISWAP = {
  text: '#FF007A',
  bg: CssUtil.addTransparency('#FF007A', 0.95),
}
const DEDUST = { text: '#4cc3dc', bg: 'rgba(76, 195, 220, 0.1)' }
const PUMP_FUN = {
  text: '#58D493',
  bg: CssUtil.addTransparency('#58D493', 0.95),
}
const PUMP_FUN_MAYHEM = {
  text: '#ED505C',
  bg: 'rgba(255, 67, 57, 0.10)',
}
const PUMP_SWAP = {
  text: '#58D493',
  bg: CssUtil.addTransparency('#58D493', 0.95),
}
const STONFI = { text: '#4cc3dc', bg: 'rgba(76, 195, 220, 0.1)' }
const DELUGE = { text: '#4cc3dc', bg: 'rgba(76, 195, 220, 0.1)' }
const PANCAKESWAP = {
  text: '#3ED4E0',
  bg: CssUtil.addTransparency('#3ED4E0', 0.95),
}

export const PROVIDER_PILL_COLORS_MAP: Record<
  Provider.InternalId,
  ProviderColors
> = {
  ['orca']: ORCA,
  ['jupiter']: JUPITER,
  ['meteora-dyn']: METEORA,
  ['meteora-dlmm']: METEORA,
  ['raydium-v4']: RAYDIUM,
  ['raydium-cpmm']: RAYDIUM,
  ['raydium-clmm']: RAYDIUM,
  ['raydium-launchpad']: RAYDIUM,
  ['bonk-fun']: BONK_FUN,
  ['uniswap-v2']: UNISWAP,
  ['uniswap-v3']: UNISWAP,
  ['dedust']: DEDUST,
  ['pump-fun']: PUMP_FUN,
  ['pump-fun-mayhem']: PUMP_FUN_MAYHEM,
  ['pump-swap']: PUMP_SWAP,
  ['stonfi-v1']: STONFI,
  ['stonfi-v2']: STONFI,
  ['deluge-vlmm']: DELUGE,
  ['pancakeswap-v1']: PANCAKESWAP,
  ['pancakeswap-v2']: PANCAKESWAP,
  ['pancakeswap-v3']: PANCAKESWAP,
}
